import { tbwGlobalActionTypes } from '../constants/tbw-action-types';
const intialState = {
    // use uuid to trigger useEffect in TBWCreateView
    // setting and resetting bool state as switch might be to slow to catch certain changes
    initiateSave: 0,
    initateSubmit: false,
    initiatePreview: false,
    initiateDelete: false,
};

export const tbwInitiateGlobalReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case tbwGlobalActionTypes.INITIATE_GLOBAL_SAVE:
            return { ...state, initiateSave: payload };
        case tbwGlobalActionTypes.INITIATE_GLOBAL_PREVIEW:
            return { ...state, initiatePreview: payload };
        case tbwGlobalActionTypes.INITIATE_DELETE_UTUT:
            return { ...state, initiateDelete: payload };
        case tbwGlobalActionTypes.INITIATE_SUBMIT_UTUT:
            return { ...state, initateSubmit: payload };
        default:
            return state;
    }
};
